<template>
  <el-row style="padding: 20px" :gutter="20">
    <el-container>
      <el-main style="padding: 0; background-color: white">
        <el-col :span="24" style="margin-bottom: 20px;">
          <el-radio-group v-model="currentStatus" @change="handleStatusChange">
            <el-radio-button :label="0">全部</el-radio-button>
            <el-radio-button :label="1">进行中</el-radio-button>
            <el-radio-button :label="2">已完成</el-radio-button>
            <el-radio-button :label="3">失败</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-table
            :data="taskList"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
        >
          <el-table-column prop="id" label="任务ID" width="80"></el-table-column>
          <el-table-column prop="taskType" label="任务类型" width="180">
            <template slot-scope="scope">
              {{ getTaskTypeName(scope.row.taskType) }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="数据起始时间" width="180" v-if="currentStatus !== 3">
            <template slot-scope="scope">
              {{ scope.row.startTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="数据截止时间" width="180" v-if="currentStatus !== 3">
            <template slot-scope="scope">
              {{ scope.row.endTime || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="currentStatus === 3 ? '说明' : '状态'" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" v-if="currentStatus !== 3">
            <template slot-scope="scope">
              <el-button
                  v-if="scope.row.status === 'COMPLETED'"
                  type="primary"
                  size="small"
                  @click="handleDownload(scope.row)"
              >
                下载文件
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer style="background-color: white">
        <el-col :span="24">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
          </el-pagination>
        </el-col>
      </el-footer>
    </el-container>
  </el-row>
</template>

<script>
export default {
  name: 'ExportTaskManagement',
  data() {
    return {
      taskList: [],
      loading: false,
      currentStatus: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 任务类型映射
      taskTypeMap: {
        stockTable: '库存信息统计表',
        spuSalesRankTable: '商品销量数据统计表',
        salesTable: '销售统计表',
        orderListTable: '订单明细表'
      }
    }
  },
  methods: {
    // 获取任务列表
    fetchTaskList() {
      this.loading = true
      this.$store.dispatch("Statistics/getall", {
        status: this.currentStatus,
        page: this.currentPage - 1, // 后端从0开始计数
        pageSize: this.pageSize
      })
        .then(response => {
          const { data } = response.data
          this.taskList = data.list
          this.total = data.totalCount
          this.loading = false
        })
        .catch(error => {
          this.$message.error('获取任务列表失败')
          console.error('获取任务列表失败:', error)
          this.loading = false
        })
    },

    // 获取任务类型名称
    getTaskTypeName(type) {
      return this.taskTypeMap[type] || type
    },

    // 获取状态样式
    getStatusType(status) {
      const statusMap = {
        'COMPLETED': 'success',
        'IN_PROGRESS': 'warning',
        'FAILED': 'danger'
      }
      return statusMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        'COMPLETED': '已完成',
        'IN_PROGRESS': '进行中',
        'FAILED': '失败'
      }
      return statusMap[status] || status
    },

    // 处理下载
    handleDownload(row) {
      if (row.filePath) {
        // 从 filePath 中提取文件名
        const filePathParts = row.filePath.split('/');
        const fileName = filePathParts[filePathParts.length - 1];
        
        // 对文件名进行 URL 编码
        const encodedFileName = encodeURIComponent(fileName);
        
        // 显示加载中
        this.loading = true;
        
        // 使用 Axios 发送请求
        this.$store.dispatch("ExportTask/downloadFile", encodedFileName)
          .then(response => {
            // 创建 Blob 对象
            const blob = new Blob([response.data]);
            
            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            
            // 清理
            setTimeout(() => {
              window.URL.revokeObjectURL(url);
              document.body.removeChild(link);
              this.loading = false;
            }, 100);
          })
          .catch(error => {
            console.error('下载文件失败:', error);
            this.$message.error('下载文件失败');
            this.loading = false;
          });
      } else {
        this.$message.warning('文件路径不存在');
      }
    },

    // 处理状态切换
    handleStatusChange() {
      this.currentPage = 1
      this.fetchTaskList()
    },

    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchTaskList()
    },

    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchTaskList()
    }
  },
  mounted() {
    this.fetchTaskList()
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}
</style> 